export default __webpack_public_path__ + "c64e902f226b1396b6d2cef32050fcd0.svg";